

import React, { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Chip,
  useTheme
} from '@mui/material';
import { Warning } from '@mui/icons-material';
import SectionHeader from './SectionHeader';
import { useAuth } from './../../../AuthContext';

const AlertsDisplay = () => {
 
  const [loading, setLoading] = useState(false);
  const { pumpStats } = useAuth();
  const alerts = pumpStats?.alerts ?? [];
  const theme = useTheme();
  

  // Color coding for priority
  const getPriorityColor = (priority) => {
    switch ((priority || '').toLowerCase()) {
      case 'high':
        return 'error';
      case 'medium':
        return 'warning';
      case 'low':
        return 'success';
      default:
        return 'default';
    }
  };

  return (
    <Paper
      sx={{
        borderRadius: theme.shape.borderRadius * 2,
        overflow: 'hidden',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: 2,
     
      }}
    >
      <SectionHeader icon={<Warning fontSize="small" />} title="Pump Alerts" />
       <Grid container spacing={1} sx={{ 
              p: 2,
              flex: 1,
             
              
              alignContent: 'flex-start'
            }}>
        {loading ? (
          <Typography variant="body1" align="center">
            Loading alerts...
          </Typography>
        ) : alerts.length === 0 ? (
          <Typography variant="body1" align="center">
            No alerts found for this pump.
          </Typography>
        ) : (
          <TableContainer
            sx={{
              maxHeight: 300, // Fixed height for scrolling
              overflowY: 'auto',
            }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Typography variant="subtitle2" fontWeight="bold" fontSize={'1rem'}>
                      Alert Code
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="subtitle2" fontWeight="bold" fontSize={'1rem'}>
                      Priority
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="subtitle2" fontWeight="bold" fontSize={'1rem'}>
                      Description
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="subtitle2" fontWeight="bold"fontSize={'1rem'}>
                      Time
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {alerts.map((alert,index) => (
                  <TableRow key={alert._id || index} hover>
                    <TableCell>
                      <Typography variant="body2">{alert.alert_code}</Typography>
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={alert.alert_level}
                        color={getPriorityColor(alert.alert_level)}
                        size="small"
                      />
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">{alert.description}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">
                        { new Date(alert.time).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", hour12: true, })}</Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Grid>
    </Paper>
  );
};

export default AlertsDisplay;